export const generateYearsArray = ({ startYear, endYear }: { startYear: number; endYear: number }) => {
  const yearsArray: { id: string; value: string }[] = [];

  for (let year = startYear; year <= endYear; year++) {
    yearsArray.push({ id: year.toString(), value: year.toString() });
  }

  return yearsArray.reverse();
};
